import React, { useState } from 'react';
import { resetPassword } from '../api/ideas';

function ResetPasswordModal({ closeModal, resetToken = '', openLoginModal, onSuccessNavigate = null }) {
  const [password, setPassword] = useState('');
  const [passwordConfirm, setPasswordConfirm] = useState('');
  const [error, setError] = useState('');

  // If no reset token, show contact admin message
  if (!resetToken) {
    return (
      <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
        <div className="bg-[var(--bg-secondary)] p-6 rounded-xl shadow-lg max-w-md w-full">
          <h3 className="text-lg font-semibold mb-4 text-[var(--text-primary)]">Password Reset</h3>
          
          <div className="bg-blue-100 border border-blue-400 text-blue-700 px-4 py-3 rounded-lg mb-4">
            <div className="flex">
              <div className="flex-shrink-0">
                <svg className="h-5 w-5 text-blue-400" viewBox="0 0 20 20" fill="currentColor">
                  <path fillRule="evenodd" d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7-4a1 1 0 11-2 0 1 1 0 012 0zM9 9a1 1 0 000 2v3a1 1 0 001 1h1a1 1 0 100-2v-3a1 1 0 00-1-1H9z" clipRule="evenodd" />
                </svg>
              </div>
              <div className="ml-3">
                <h3 className="text-sm font-medium text-blue-800">
                  Password Reset Required
                </h3>
                <div className="mt-2 text-sm text-blue-700">
                  <p>
                    To reset your password, please contact an administrator. They can generate a password reset link for you.
                  </p>
                </div>
              </div>
            </div>
          </div>

          <div className="flex justify-end">
            <button
              type="button"
              className="px-4 py-2 bg-[var(--secondary)] text-[var(--text-primary)] rounded-lg text-sm hover:bg-opacity-80 transition-colors"
              onClick={closeModal}
            >
              Close
            </button>
          </div>
        </div>
      </div>
    );
  }

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    
    if (password !== passwordConfirm) {
      setError('Passwords do not match');
      return;
    }
    
    if (password.length < 6) {
      setError('Password must be at least 6 characters long');
      return;
    }
    
    try {
      await resetPassword(resetToken, password, passwordConfirm);
      // Close reset password modal first
      closeModal();
      // Navigate away from reset-password URL if we're on it
      if (onSuccessNavigate) {
        onSuccessNavigate();
      }
      // Then open login modal
      if (openLoginModal) {
        setTimeout(() => {
          openLoginModal();
        }, 100); // Small delay to ensure smooth transition
      }
    } catch (err) {
      setError(err.response?.data?.detail || err.message);
    }
  };

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
      <div className="bg-[var(--bg-secondary)] p-6 rounded-xl shadow-lg max-w-md w-full">
        <h3 className="text-lg font-semibold mb-4 text-[var(--text-primary)]">Reset Password</h3>
        
        {error && (
          <div className="bg-danger-light border text-danger px-4 py-2 rounded-lg mb-4">
            {error}
          </div>
        )}
        
        <form onSubmit={handleSubmit}>
          <div className="mb-4">
            <input
              type="password"
              className="w-full p-2 border border-gray-300 dark:border-slate-600 rounded-lg text-[var(--text-primary)] bg-[var(--bg-secondary)] focus:ring-2 focus:ring-[var(--primary)]"
              placeholder="New Password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
            />
          </div>
          <div className="mb-4">
            <input
              type="password"
              className="w-full p-2 border border-gray-300 dark:border-slate-600 rounded-lg text-[var(--text-primary)] bg-[var(--bg-secondary)] focus:ring-2 focus:ring-[var(--primary)]"
              placeholder="Confirm New Password"
              value={passwordConfirm}
              onChange={(e) => setPasswordConfirm(e.target.value)}
              required
            />
          </div>
          <div className="flex gap-2">
            <button
              type="submit"
              className="flex-1 px-4 py-2 bg-[var(--primary)] text-white rounded-lg text-sm hover:bg-opacity-80 transition-colors"
            >
              Reset Password
            </button>
            <button
              type="button"
              className="px-4 py-2 bg-[var(--secondary)] text-[var(--text-primary)] rounded-lg text-sm hover:bg-opacity-80 transition-colors"
              onClick={closeModal}
            >
              Cancel
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}

export default ResetPasswordModal;